import { render, staticRenderFns } from "./one.vue?vue&type=template&id=94cf52de&scoped=true&"
import script from "./one.vue?vue&type=script&lang=js&"
export * from "./one.vue?vue&type=script&lang=js&"
import style0 from "./one.vue?vue&type=style&index=0&id=94cf52de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf52de",
  null
  
)

export default component.exports